<div class="ultra-loader" *ngIf="isLoading">



  <!-- SHIP SECTION -->
  <div class="ship-wrapper">
    <div class="ship-body">
      🚢
    </div>
    <div class="wheel">⚓</div>
  </div>

  <!-- TEXT -->
  <div class="loader-text">
    <h2>Voyage Intelligence Loading</h2>
    <p>Analyzing Sea & Port Performance...</p>
  </div>

  <!-- PROGRESS -->
  <div class="progress-container">
    <div class="progress-line"></div>
  </div>

</div>

<div class="premium-container" *ngIf="!isLoading">

  <div class="premium-filter-wrapper">
    <form [formGroup]="filterForm" class="premium-filter">

      <div class="filter-group">
        <label class="filter-label">
          <mat-icon>directions_boat</mat-icon>
          Vessel
        </label>
        <select formControlName="vesselName" class="filter-input">
          <option value="">Select Vessel</option>
          <option *ngFor="let vessel of vesselList" [value]="vessel.vesselIMO">
            {{ vessel.vesselName }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label class="filter-label">
          <mat-icon>event</mat-icon>
          From Date
        </label>
        <input type="date" formControlName="fromDate" class="filter-input" />
      </div>

      <div class="filter-group">
        <label class="filter-label">
          <mat-icon>event_available</mat-icon>
          To Date
        </label>
        <input type="date" formControlName="toDate" class="filter-input" />
      </div>

      <div class="filter-group">
        <label class="filter-label">
          <mat-icon>assignment</mat-icon>
          Report Type
        </label>
        <select formControlName="reportType" class="filter-input">
          <option value="all">All</option>
          <option value="sea">Sea Report</option>
          <option value="port">Port Report</option>
        </select>
      </div>

      <div class="filter-group">
        <label class="filter-label">
          <mat-icon>swap_vert</mat-icon>
          Voyage Phase
        </label>
        <select formControlName="voyagePhase" class="filter-input">
          <option value="both">Both</option>
          <option value="Laden">Laden</option>
          <option value="Ballast">Ballast</option>
        </select>
      </div>

      <div class="filter-buttons">
        <button type="button" class="btn-view d-flex align-items-center justify-content-center" (click)="viewClick()">
          <mat-spinner *ngIf="isSubmitting" diameter="18" class="me-2"></mat-spinner>

          {{ isSubmitting ? "Checking..." : "View" }}
        </button>

        <button type="button" class="btn-download" (click)="downloadClick()">
          <mat-icon>download</mat-icon>
          Download
        </button>
      </div>

    </form>
  </div>

  <div class="empty-state" *ngIf="!allReports || allReports.length === 0">
    <mat-icon>analytics</mat-icon>
    <h3>No Reports Loaded</h3>
    <p>Select filters and click <b>View</b> to display voyage data.</p>
  </div>

  <div class="reports-wrapper" *ngIf="allReports && allReports.length > 0">

    <div *ngFor="let item of allReports" class="report-card" [ngClass]="{
       'sea-card': item.label === 'Sea Passage',
       'port-card': item.label === 'Port Passage',
       'transit-card': item.label === 'Transit'
     }">

      <div class="report-header" (click)="toggleItem(item)">

        <div class="left">
          <mat-icon>

            {{ item.label === 'Sea Passage' ? 'waves' : 'anchor' }}
          </mat-icon>

          <div>
            <h4>
              {{ item.voyage_number }} -
              {{ item.label }} <span *ngIf="item.operation">- {{ item.operation }}</span>
              <span *ngIf="item.label === 'Sea Passage'">
                ({{ item.cargo_quantity > 0 ? 'Laden' : 'Ballast' }})
              </span>
            </h4>
            <span>
              {{ item.from_date | date:'d MMM yyyy HH:mm':'UTC' }}
              →
              {{ item.to_date | date:'d MMM yyyy HH:mm':'UTC' }}
            </span>
            <br>
            <span class="route-center" *ngIf="item.from_port && item.to_port">
              {{ item.from_port }} → {{ item.to_port }}
            </span>
            <span class="route-center" *ngIf="item.port">
              {{ item.port }}
            </span>
          </div>
        </div>
        <div class="header-summary">

          <!-- <div class="stat">
            <span class="label">Voyage Number</span>
            <span class="value">{{ item.voyage_number }}</span>
          </div> -->

          <div class="stat">
            <span class="label">Total Hrs</span>
            <span class="value">{{ item.total_hours }}</span>
          </div>
          <div class="stat">
            <span class="label">Total Dist</span>
            <span class="value">{{ item.distance?.travelled }}</span>
          </div>

          <!-- Sea Passage -->
          <!-- <div class="stat" *ngIf="item.label === 'Sea Passage'">
            <span class="label">
              {{ item.cargo_quantity > 0 ? 'Laden' : 'Ballast' }}
            </span>
          </div> -->

          <div class="stat" *ngIf="item.label === 'Sea Passage'">
            <span class="label">Steaming Hrs</span>
            <span class="value">{{ item.steaming_hours }}</span>
          </div>

          <!-- Transit / Port -->
          <ng-container *ngIf="item.label === 'Transit' || item.label === 'Port Stay'">

            <div class="stat" *ngIf="(item.consumption?.incineratorGasOil ?? 0) > 0">
              <span class="label">Incinerator Cons</span>
              <span class="value">{{ item.consumption?.incineratorGasOil }} Mt</span>
            </div>

            <div class="stat" *ngIf="(item.consumption?.gasOilPowerPack ?? 0) > 0">
              <span class="label">Power Pack Cons</span>
              <span class="value">{{ item.consumption?.gasOilPowerPack }} Mt</span>
            </div>

          </ng-container>

          <!-- Fuel Consumption -->
          <ng-container *ngFor="let fuel of fuelTypes">
            <div class="stat" *ngIf="(item.consumption?.[fuel] ?? 0) > 0">
              <span class="label">{{ fuel }} Cons</span>
              <span class="value">{{ item.consumption?.[fuel] }} Mt</span>
            </div>
          </ng-container>

          <!-- Bunker ROBs -->
          <div class="stat" *ngIf="(item.rob?.new?.HSFO ?? 0) > 0">
            <span class="label">HSFO ROB</span>
            <span class="value">{{ item.rob?.new?.HSFO }} Mt</span>
          </div>
          <div class="stat" *ngIf="((item.rob?.new?.VLSFO ?? 0) > 0) || ((item.rob?.new?.ULSFO ?? 0) > 0)">
            <span class="label">LSFO ROB</span>
            <span class="value">{{ (item.rob?.new?.VLSFO ?? 0) + (item.rob?.new?.ULSFO ?? 0) }} Mt</span>
          </div>
          <div class="stat" *ngIf="(item.rob?.new?.MGO ?? 0) > 0">
            <span class="label">GO ROB</span>
            <span class="value">{{ item.rob?.new?.MGO }} Mt</span>
          </div>

          <!-- Weather Section -->
          <div class="stat" *ngIf="item.weather?.swellHeight">
            <span class="label">Avg Swell Height</span>
            <span class="value">{{ item.weather?.swellHeight }} m</span>
          </div>

          <div class="stat" *ngIf="item.weather?.trueWindKnots">
            <span class="label">Avg Wind Speed</span>
            <span class="value">{{ item.weather?.trueWindKnots }} kn</span>
          </div>
          <div class="stat" *ngIf="item.weather?.trueWindKnots">
            <span class="label">Avg Sea Height</span>
            <span class="value">{{ item.weather?.seaHeight }} kn</span>
          </div>
        </div>


        <!-- <div class="right">
          <span class="badge">{{ item.report_count }} Reports</span>
          <mat-icon class="arrow">
            {{ item.expanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div> -->

        <div class="right d-flex align-items-center">

          <!-- Download All Reports -->
          <button mat-icon-button class="download-all-btn" matTooltip="Download All Reports" matTooltipPosition="above"
            (click)="downloadAllReports(item, $event)">
            <mat-icon>download</mat-icon>
          </button>

          <!-- Download Sea Report CSV (Sea Passage only) -->
          <button mat-icon-button class="download-csv-btn"
            *ngIf="item.label === 'Sea Passage'"
            [disabled]="item._csvDownloading"
            matTooltip="Download Sea Performance CSV"
            matTooltipPosition="above"
            (click)="downloadSeaReportCsv(item, $event)"
            style="position: relative; width: 40px; height: 40px;">
            
            <ng-container *ngIf="item._csvDownloading">
              <mat-progress-spinner 
                color="accent"
                mode="determinate" 
                [value]="item._csvProgress || 0" 
                diameter="30"
                style="position: absolute; top: 5px; left: 5px;">
              </mat-progress-spinner>
              <span style="position: absolute; top: 0; left: 0; width: 40px; height: 40px; line-height: 40px; text-align: center; font-size: 10px; font-weight: bold; color: #fff;">
                {{ item._csvProgress || 0 }}%
              </span>
            </ng-container>

            <mat-icon *ngIf="!item._csvDownloading">table_chart</mat-icon>
          </button>

          <span class="badge">{{ item.report_count }} Reports</span>

          <mat-icon class="arrow">
            {{ item.expanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>

        </div>


      </div>

      <div class="report-body" *ngIf="item.expanded">

        <div *ngIf="item.loadingDetails" class="loading-details">
          <mat-spinner diameter="30"></mat-spinner>
          <span>Loading detailed reports...</span>
        </div>

        <div *ngIf="!item.loadingDetails && item.detailReports?.length">

          <div class="detail-card" *ngFor="let detail of item.detailReports">

            <!-- Detail Header -->
            <div class="detail-header">

              <div class="left-detail">
                <mat-icon>description</mat-icon>
                {{ detail.eventsList }} | {{ detail.report_timestamp | date:'dd-MMM-yyyy HH:mm:ss':'UTC' }}
              </div>

              <div class="right-detail">

                <!-- View -->
                <mat-icon class="eye-icon" matTooltip="View Report" matTooltipPosition="above"
                  *ngIf="!detail.isViewing"
                  (click)="editReport(detail, $event)">
                  visibility
                </mat-icon>
                <mat-spinner *ngIf="detail.isViewing" diameter="18" class="ms-1 me-1"></mat-spinner>

                <!-- Download Single Report -->
                <mat-icon matTooltip="Download This Report" matTooltipPosition="above"
                  (click)="downloadSingleReport(detail, $event , item.label)">
                  download
                </mat-icon>

                <span class="status-badge" [ngClass]="{
      'force': detail.force_submission,
      'verified': detail.verified && !detail.force_submission,
      'unverified': !detail.verified && !detail.force_submission
    }">

                  {{ detail.force_submission
                  ? 'Force Submission'
                  : detail.verified
                  ? 'Verified'
                  : 'Unverified' }}

                </span>

              </div>

            </div>

            <div class="detail-grid">

              <!-- 📍 NAVIGATION -->
              <div class="detail-section">
                <div class="section-title">📍 Navigation</div>

                <div class="stat" *ngIf="detail.steamingHoursReport">
                  <span>Steaming Hours</span>
                  <strong>{{ detail.steamingHoursReport }} hrs</strong>
                </div>

                <div class="stat" *ngIf="detail.steamingDistanceGps">
                  <span>Distance (GPS)</span>
                  <strong>{{ detail.steamingDistanceGps }} Nm</strong>
                </div>

                <div class="stat" *ngIf="detail.speed_nm">
                  <span>Speed</span>
                  <strong>{{ detail.speed_nm }} kn</strong>
                </div>
              </div>

              <!-- 🌦 WEATHER -->
              <div class="detail-section">
                <div class="section-title">🌦 Weather</div>

                <div class="stat" *ngIf="detail.air_temp_degC">
                  <span>Air Temp</span>
                  <strong>{{ detail.air_temp_degC }} °C</strong>
                </div>

                <div class="stat" *ngIf="detail.swell_m">
                  <span>Swell Height</span>
                  <strong>{{ detail.swell_m }} m</strong>
                </div>

                <div class="stat" *ngIf="detail.wind_knots">
                  <span>Wind Speed</span>
                  <strong>{{ detail.wind_knots }} kn</strong>
                </div>
              </div>

              <!-- ⚙ ENGINE & FUEL -->
              <div class="detail-section">
                <div class="section-title">⚙ Engine & Fuel</div>

                <div class="stat" *ngIf="detail.me_consumption">
                  <span>Main Engine</span>
                  <strong>{{ detail.me_consumption }} Mt</strong>
                </div>

                <div class="stat" *ngIf="detail.ae_consumption">
                  <span>Aux Engine</span>
                  <strong>{{ detail.ae_consumption }} Mt</strong>
                </div>

                <div class="stat" *ngIf="detail.blr_consumption">
                  <span>Boiler</span>
                  <strong>{{ detail.blr_consumption }} Mt</strong>
                </div>

                <div class="stat" *ngIf="detail.others_consumption">
                  <span>Others</span>
                  <strong>{{ detail.others_consumption }} Mt</strong>
                </div>

                <div class="stat total" *ngIf="detail.total_consumption">
                  <span>Total Consumption</span>
                  <strong>{{ detail.total_consumption }} Mt</strong>
                </div>

                <div class="stat" *ngIf="detail.fo_consumption_mt">
                  <span>Total FO</span>
                  <strong>{{ detail.fo_consumption_mt }} Mt</strong>
                </div>

                <div class="stat" *ngIf="detail.mgoTotalConsumption">
                  <span>Total GO</span>
                  <strong>{{ detail.mgoTotalConsumption }} Mt</strong>
                </div>

                <div class="stat" *ngIf="(detail.hsfo_rob ?? 0) > 0">
                  <span>HSFO ROB</span>
                  <strong>{{ detail.hsfo_rob }} Mt</strong>
                </div>

                <div class="stat" *ngIf="(detail.lsfo_rob ?? 0) > 0">
                  <span>LSFO ROB</span>
                  <strong>{{ detail.lsfo_rob }} Mt</strong>
                </div>

                <div class="stat" *ngIf="(detail.go_rob ?? 0) > 0">
                  <span>GO ROB</span>
                  <strong>{{ detail.go_rob }} Mt</strong>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>